import { useRunMetadataTransport } from "@/runs"
import { Tooltip } from "@coval/ui"
import { Check, Copy } from "lucide-react"

import { useCopyToClipboard } from "@/hooks/useCopyToClipboard"

export function RunBreadcrumbContent({ runId }: { runId: string }) {
  const { data } = useRunMetadataTransport(runId, { enabled: !!runId })

  const displayName = data?.run?.display_name?.trim() || runId

  return <span>{displayName}</span>
}

export function RunBreadcrumbContentWithCopy({ runId }: { runId: string }) {
  const { data } = useRunMetadataTransport(runId, { enabled: !!runId })
  const { copied, copy } = useCopyToClipboard()

  const displayName = data?.run?.display_name?.trim() || runId

  return (
    <span className="flex items-center gap-1">
      <span>{displayName}</span>
      <Tooltip content={copied ? "Copied!" : "Copy ID"}>
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            void copy(runId)
          }}
          className="p-0.5 inline-flex items-center justify-center bg-transparent border-0 cursor-pointer focus:outline-none"
          aria-label={copied ? "Copied!" : "Copy ID"}
        >
          {copied ? (
            <Check className="h-3 w-3 text-coval-success-text" />
          ) : (
            <Copy className="h-3 w-3" />
          )}
        </button>
      </Tooltip>
    </span>
  )
}
